import { AxiosResponse } from 'axios'
import { http } from '../realisations/Http.realisation'
import {
    CreateMerchantPayloadT,
    GetMerchantParams,
    GetMerchantsListResponseT,
} from '../types/merchants.types'

export class MerchantsRepository {
    getMerchantsList(params: GetMerchantParams): Promise<AxiosResponse<GetMerchantsListResponseT>> {
        return http.get('/verification/api/merchant', { params })
    }

    createMerchant(payload: CreateMerchantPayloadT): Promise<AxiosResponse<void>> {
        return http.post('/verification/api/merchant', payload)
    }

    updateMerchant(
        merchant_id: number,
        payload: CreateMerchantPayloadT
    ): Promise<AxiosResponse<void>> {
        return http.put(`/verification/api/merchant/${merchant_id}`, payload)
    }

    deleteMerchant(merchant_id: number): Promise<AxiosResponse<void>> {
        return http.delete(`/verification/api/merchant/${merchant_id}`)
    }
}
